import React, { useState, useEffect } from "react";
import { RiArrowUpDownFill } from "react-icons/ri";
import SingleDropdown from "../../components/SingleDropdown";
import "./CourseCalendar.css";
import CalendarComponent from "../../components/CalendarComponent";
import { giveTextColor } from "../../helpers/textColors";
import ShowCalendarBatch from "../../components/ShowCalendarBatch";
import axios from 'axios'
import { ToastContainer, toast } from "react-toastify";
import { logout } from '../../store/authSlice.js'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useTitle } from '../../hooks/useTitle.js'
import { useParams } from 'react-router-dom'
import constant from '../../constant/constant.js'
import { setUser } from "../../store/authSlice.js";

const courseOptions = [
  { value: "small", label: "Small RPC" },
  { value: "medium", label: "Medium RPC" },
  { value: "cpl", label: "CPL" },
];
const timeZoneOptions = [
  { value: "UTC +00:00 Africa/Abidjan", label: "UTC +00:00 Africa/Abidjan" },
  { value: "UTC +00:00 Africa/Accra", label: "UTC +00:00 Africa/Accra" },
  {
    value: "UTC +03:00 Africa/Addis_Ababa",
    label: "UTC +03:00 Africa/Addis_Ababa",
  },
];



const CourseCalendar = () => {

  const user = useSelector(state => state.auth);
  useTitle('Manage Profile - Flapone Aviation');
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [dataStatus, setDataStatus] = useState(false);
  const [upcomingBatchStatus, setUpcomingBatchStatus] = useState(false);
  const [courseListOptions, setCourseListData] = useState([]);
  const [selectedCourseOption, setSelectedCourseOption] = useState([]);

  const [freeUserStatus, setFreeUserStatus] = useState(false);

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [activeColumn, setActiveColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");

  const checkUserLogin = response => {
      if (response.data.login.status === 0) {
        dispatch(logout())
        navigate('/login')
      }
    }

  const handleCourseChange = (option) => {
    setSelectedCourseOption(option);
    checkCourseData(option);
  };


 const [totalNoOfClass , setTotalNoOfClass]= useState(0);

 const studentCourseList = () => {
  axios({
    method: 'post',
    url: `${constant.base_url}/student/student_calendar.php?fun=studentCourseList`,
    headers: { 'Auth-Id': user.auth_id },
    data: {
    }
  })
    .then((response) => {
      checkUserLogin(response);
      if (response.data.data.status === 1) {
         setCourseListData(response.data.data.course_list);

        if(response.data.data.running_course){
          setCurrentPage(response.data.data.tab_position);
          setSelectedCourseOption(response.data.data.running_course_arr);
          getStudentClassData(response.data.data.tab_position,response.data.data.running_course_arr);
        }else if(response.data.data.not_assign_batch){
          
          setSelectedCourseOption(response.data.data.not_assign_batch_arr);
          setUpcomingBatchStatus(response.data.data.upcoming_batch);
          checkCourseData(response.data.data.not_assign_batch_arr);
        }else if(response.data.data.free_user_course){
          
          setSelectedCourseOption(response.data.data.free_user_course_arr);
          setUpcomingBatchStatus(response.data.data.upcoming_batch);
          setFreeUserStatus(true);
          checkCourseData(response.data.data.free_user_course_arr);

        }

      }
    })
    .catch((error) => {
      console.error('Error fetching class data:', error);
    });
};

 const getStudentClassData = (pageNo = 1,courseOption) => {
  setDataStatus(false);
  axios({
    method: 'post',
    url: `${constant.base_url}/student/student_calendar.php?fun=studentClasses`,
    headers: { 'Auth-Id': user.auth_id },
    data: {
      page_no: pageNo,
      selected_course:courseOption?courseOption:selectedCourseOption,
    }
  })
    .then((response) => {
      checkUserLogin(response);
     
      if (response.data.data.status === 1) {
        setUpcomingBatchStatus(response.data.data.upcoming_batch);
        setData(response.data.data.classlist);
        setTotalNoOfClass(response.data.data.no_of_records);
        setDataStatus(true);
      }
    })
    .catch((error) => {
      console.error('Error fetching class data:', error);
    });
};


const checkCourseData = (courseOption) => {
  setUpcomingBatchStatus(false);
  axios({
    method: 'post',
    url: `${constant.base_url}/student/student_calendar.php?fun=checkStudentCourse`,
    headers: { 'Auth-Id': user.auth_id },
    data: {
      selected_course:courseOption,
    }
  })
    .then((response) => {
      checkUserLogin(response);
      if (response.data.data.status === 1) {
        if(response.data.data.batch_not_assign_status){
         setUpcomingBatchStatus(response.data.data.batch_not_assign_status);
        }else if(response.data.data.free_user_status){
         setUpcomingBatchStatus(response.data.data.batch_not_assign_status);
         setFreeUserStatus(response.data.data.free_user_status);
        }else{
          getStudentClassData(response.data.data.tab_position,courseOption);
        }
      }
    })
    .catch((error) => {
      console.error('Error fetching class data:', error);
    });
};

const studentEnrollBatchFun = (batchdata) => {
  axios({
    method: 'post',
    url: `${constant.base_url}/student/student_calendar.php?fun=studentEnrollBatch`,
    headers: { 'Auth-Id': user.auth_id },
    data: {
      batchdata:batchdata,
      course_id:selectedCourseOption.value,
      course_name:selectedCourseOption.label,
      location:constant.weburl+"calendar",
    }
  })
    .then((response) => {
       checkUserLogin(response);
      if (response.data.data.status === '0') {
        toast.warning(response.data.data.msg);
      }else if (response.data.data.status === '1') {
        toast.success(response.data.data.msg);
      }
    })
    .catch((error) => {
      console.error('Error fetching class data:', error);
    });
};

const studentBatchAssignFun = (batchdata) => {
  axios({
    method: 'post',
    url: `${constant.base_url}/student/student_calendar.php?fun=assignBatchToStudent`,
    headers: { 'Auth-Id': user.auth_id },
    data: {
      batchdata:batchdata,
      selected_course:selectedCourseOption,
    }
  })
    .then((response) => {
       checkUserLogin(response);
      if (response.data.data.status === '0') {
        toast.warning(response.data.data.msg);
      }else if (response.data.data.status === '1') {
        toast.success(response.data.data.msg);
        getStudentClassData(currentPage);
      }
    })
    .catch((error) => {
      console.error('Error fetching class data:', error);
    });
};



  const handlePrev = () => {
    if (currentPage > 0) {
      setCurrentPage(prev => prev - 1);
    }
  };

  const handleNext = () => {
    if ((currentPage) * 7 < totalNoOfClass) {
      setCurrentPage(prev => prev + 1);
    }
  };

   useEffect(() => {
    studentCourseList();
  }, []);


  useEffect(() => {
    getStudentClassData(currentPage);
  }, [currentPage]);


 const paginatedData = data;

  const handleHeaderClick = (column) => {
  let newSortDirection = "asc";

  if (activeColumn === column) {
    newSortDirection = sortDirection === "asc" ? "desc" : "asc";
  } else {
    setActiveColumn(column);
  }

  const getValue = (item) => {
    if (column === "date" || column === "day") {
      return item[column] || "";
    }

    // Get value from first class object if available
    const cls = item.classes?.[0] || {};
    return cls[column] || "";
  };

  const parseValue = (val) => {
    if (column === "startTime" || column === "endTime") {
      return new Date(`1970/01/01 ${val}`);
    }
    if (column === "date") {
      return new Date(val);
    }
    return typeof val === "string" ? val.toLowerCase() : val;
  };

  const sortedData = [...data].sort((a, b) => {
    const valA = parseValue(getValue(a));
    const valB = parseValue(getValue(b));

    if (valA instanceof Date && valB instanceof Date) {
      return newSortDirection === "asc" ? valA - valB : valB - valA;
    }

    if (typeof valA === "string" && typeof valB === "string") {
      return newSortDirection === "asc"
        ? valA.localeCompare(valB)
        : valB.localeCompare(valA);
    }

    if (typeof valA === "number" && typeof valB === "number") {
      return newSortDirection === "asc" ? valA - valB : valB - valA;
    }

    return 0;
  });

  setSortDirection(newSortDirection);
  setData(sortedData);
};


  const getHeaderProps = (column) => {
    const isActive = activeColumn === column;
    const isAsc = sortDirection === "asc";
    return {
      onClick: () => handleHeaderClick(column),
      headerClass: `box-center ${
        isActive ? (isAsc ? "fc3 asc" : "fc2 desc") : ""
      }`,
      iconClass: `cp ml4 ${isActive ? (isAsc ? "fc3 asc" : "fc2 desc") : ""}`,
    };
  };


  

  return (
    <div className="course-container df mr20">
      <div className="w100">

      
        <div className="course-calendar-container">
          <div className="v-center jcsb  h-input batch-time">
            <div className="form-group-settings gender flx48 w100">
              <SingleDropdown
                label="Course"
                options={courseListOptions}
                selectedOption={selectedCourseOption}
                onSelect={handleCourseChange}
                required
              />
            </div>
            {/* <div className="form-group-settings gender flx48 w100 timezone">
              <SingleDropdown
                label="Timezone"
                options={timeZoneOptions}
                selectedOption={courseCalendarData.timeZone}
                onSelect={handleTimezoneChange}
                required
              />
            </div> */}
          </div>

    {!upcomingBatchStatus && paginatedData && (
           <div
            className="class-timings  pt8  mt24 w100"
            style={{ overflow: "auto" }}
          >
            <div className="address-head mb12">
              <p className="fs18 fc3 ls1 lh22">Class Timings</p>
            </div>
            <table className="w100 mt16 wsnw">
              <thead>
                <tr>
                  <th {...getHeaderProps("date")}>
                    <p className={getHeaderProps("date").headerClass}>
                      Date & Day
                      <RiArrowUpDownFill
                        className={getHeaderProps("date").iconClass}
                      />
                    </p>
                  </th>
                  <th {...getHeaderProps("type")}>
                    <p className={getHeaderProps("type").headerClass}>
                      Type
                      <RiArrowUpDownFill
                        className={getHeaderProps("type").iconClass}
                      />
                    </p>
                  </th>
                  <th {...getHeaderProps("startTime")}>
                    <p className={getHeaderProps("startTime").headerClass}>
                      Start - End Time
                      <RiArrowUpDownFill
                        className={getHeaderProps("startTime").iconClass}
                      />
                    </p>
                  </th>
                  <th {...getHeaderProps("endTime")}>
                    <p className={getHeaderProps("endTime").headerClass}>
                      Mode
                      <RiArrowUpDownFill
                        className={getHeaderProps("endTime").iconClass}
                      />
                    </p>
                  </th>
                  <th {...getHeaderProps("subject")}>
                    <p className={getHeaderProps("subject").headerClass}>
                      Subject
                      <RiArrowUpDownFill
                        className={getHeaderProps("subject").iconClass}
                      />
                    </p>
                  </th>
                   <th {...getHeaderProps("all_chapter_name")}>
                    <p className={getHeaderProps("all_chapter_name").headerClass}>
                      Chapter Name
                      <RiArrowUpDownFill
                        className={getHeaderProps("all_chapter_name").iconClass}
                      />
                    </p>
                  </th>
                  <th {...getHeaderProps("mode")}>
                    <p className={getHeaderProps("mode").headerClass}>
                      Faculty
                      <RiArrowUpDownFill
                        className={getHeaderProps("mode").iconClass}
                      />
                    </p>
                  </th>
                  <th {...getHeaderProps("location")}>
                    <p className={getHeaderProps("location").headerClass}>
                      Venue
                      <RiArrowUpDownFill
                        className={getHeaderProps("location").iconClass}
                      />
                    </p>
                  </th>
                  <th {...getHeaderProps("attendance")}>
                    <p className={getHeaderProps("attendance").headerClass}>
                      Status
                      <RiArrowUpDownFill
                        className={getHeaderProps("attendance").iconClass}
                      />
                    </p>
                  </th>
                </tr>
              </thead>
              <tbody>
                {paginatedData.map((dayData, dayIndex) => {
                  const classesByType = dayData.classes.reduce((acc, cls) => {
                    if (!acc[cls.type]) {
                      acc[cls.type] = [];
                    }
                    acc[cls.type].push(cls);
                    return acc;
                  }, {});

                  const rowSpans = Object.keys(classesByType).reduce(
                    (acc, type) => {
                      acc[type] = classesByType[type].length;
                      return acc;
                    },
                    {}
                  );

                  return Object.keys(classesByType).map((type, typeIndex) => {
                    return classesByType[type].map((cls, clsIndex) => {
                      return (
                        <tr key={`${dayIndex}-${typeIndex}-${clsIndex}`}>
                          {typeIndex === 0 && clsIndex === 0 && (
                            <td
                              className="pl24 pr24 pt16 pb16"
                              rowSpan={dayData.classes.length}
                            >
                              <p className="fs14 lh22">{dayData.date}</p>
                            </td>
                          )}
                          {clsIndex === 0 && (
                            <td
                              className="pl24 pr24 pt16 pb16"
                              rowSpan={rowSpans[type]}
                              style={{
                                color: giveTextColor(
                                  type === "Exam"
                                    ? "green"
                                    : type === "Test"
                                    ? "orange"
                                    : type === "Quiz"
                                    ? "red"
                                    : type === "Presentation"
                                    ? "yellow"
                                    : type === "Assignment"
                                    ? "navy"
                                    : type === "Lab Session"
                                    ? "navy"
                                    : type
                                ),
                                textTransform: "capitalize",
                              }}
                            >
                              <p className="fs14 lh22">{type}</p>
                            </td>
                          )}
                          <td className="pl24 pr24 pt16 pb16">
                            <p className="fs14 lh22">
                              {cls.startTime} - {cls.endTime}
                            </p>
                          </td>
                          <td
                            className={`${cls.onlineLink && "cp fc7"}`}
                            onClick={() => {
                              if (cls.onlineLink) {
                                window.open(cls.onlineLink, "_blank");
                              }
                            }}
                          >
                            {cls.mode}
                          </td>
                          <td className="pl24 pr24 pt16 pb16">
                            <p className="fs14 lh22">{cls.subject}</p>
                          </td>

                          <td className="pl24 pr24 pt16 pb16">
                            <p className="fs14 lh22">{cls.all_chapter_name}</p>
                          </td>

                          
                          <td className="pl24 pr24 pt16 pb16">
                            <p className="fs14 lh22">{cls.faculty}</p>
                          </td>

                          <td className="pl24 pr24 pt16 pb16">
                            {cls.mode === "Online" ? (
                              <a
                                href={cls.onlineLink}
                                className="fs14 lh22"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {cls.location}
                              </a>
                            ) : (
                              <p className="fs14 lh22">{cls.location} - {cls.room_no}</p>
                            )}
                          </td>
                          <td>
                            <span
                              className={`badge-status badge ${
                                cls.attendance === "Present"
                                  ? "bg-green"
                                  : cls.attendance === "UnMark"
                                  ? "btn-blue bg1 br24 cp ls2  "
                                  : cls.attendance === "Absent"
                                  ? "bg-red"
                                  : cls.attendance === "Dropped"
                                  ? "bg-red"
                                  : "fc2"
                              }`}
                            >
                              {cls.attendance}
                            </span>
                          </td>
                        </tr>
                      );
                    });
                  });
                })}
              </tbody>
            </table>
          </div>
        )}

        {!upcomingBatchStatus && paginatedData && (
          <div className="pagination-buttons mt24 df jce brd-b2 pb24">
            <button
              className="pagination-btn cp"
              onClick={handlePrev}
              disabled={currentPage === 1}
            >
              &lt; Prev
            </button>
            <div className="page-number box-center bg3 fc1 br4" >
              {currentPage}
            </div>
            <button
              className="pagination-btn cp"
              onClick={handleNext}
              disabled={currentPage >= Math.ceil(totalNoOfClass / 7)}
            >
              Next &gt;
            </button>
          </div>
          )}
        </div>

       {upcomingBatchStatus  &&(
        <div className="course-holidays">
          <div className="df fdc mb24">
            <h3 className="fc3 fw5 fs18 mt12 mb12">
              Upcoming Batch
              <div className="fs14 fc16 mt8 fw4 fc6 lh18">
                Check out the Upcoming Batch and get enrolled just by one click.
              </div>
            </h3>
          </div>
          <div className="holiday-calendar">
            <ShowCalendarBatch 
              axios={axios}
              constant={constant}
              user={user}
              checkUserLogin={checkUserLogin}
              selectedCourseOption={selectedCourseOption}
              studentBatchAssign={studentBatchAssignFun}
              studentEnrollBatch={studentEnrollBatchFun}
              freeUserStatus={freeUserStatus}
            />
          </div>
        </div>
       )}


     {!upcomingBatchStatus && dataStatus && (
        <div className="course-holidays mt24">
          <div className="df fdc mb24">
            <h3 className="fc3 fw5 fs18 mt12 mb12">
              Holiday Calendar
              <div className="fs14 fc16 mt8 fw4 fc6 lh18">
                Check out the scheduled holidays and plan your activities
                accordingly. Stay informed about upcoming breaks and holidays.
              </div>
            </h3>
          </div>
          <div className="holiday-calendar">
            <CalendarComponent 
              axios={axios}
              constant={constant}
              user={user}
              checkUserLogin={checkUserLogin}
              selectedCourseOption={selectedCourseOption}
            />
          </div>
        </div>
       )}

      </div>
      <ToastContainer position="bottom-right" />
    </div>
  );
};

export default CourseCalendar;
